<div class="flex w-full flex-col gap-2">
  <mat-slide-toggle
    (change)="onToggle($event.checked)"
    [checked]="isAcknowledgementRequired()"
    hideIcon="true"
  >
    {{ 'task-description-acknowledgement-panel.require-acknowledgement-toggle-label' | translate }}
  </mat-slide-toggle>

  @if (isAcknowledgementRequired() && acknowledgementRows().length > 0) {
    <mat-accordion class="w-full">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="px-3 py-2">
          <mat-panel-title class="flex w-full items-center gap-2">
            <mat-icon fontIcon="how_to_reg" />
            <span>
              {{ 'task-description-acknowledgement-panel.title' | translate }} ({{ acknowledgedCount() }}/{{
                acknowledgementRows().length
              }})
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ul class="flex flex-col gap-1 px-3 pb-3 pt-0">
          @for (row of acknowledgementRows(); track row.rowId) {
            <li class="flex items-center gap-2 text-sm text-proffeo-text">
              <mat-icon [fontIcon]="row.icon" />
              <span class="shrink-0">{{ row.displayName }}</span>
              @if (row.acknowledgedAt) {
                <span class="flex-1 truncate text-right text-muted">
                  {{ row.acknowledgedAt | date: 'dd.MM.yyyy HH:mm' }}
                </span>
              }
            </li>
          }
        </ul>
      </mat-expansion-panel>
    </mat-accordion>
  }
</div>
